import React from 'react';
import i18n from 'i18n-js';
import PropTypes from 'prop-types';
import { BaseModal } from 'components/UI';
import { VehiclesGroupsServices } from 'components/Fleets';

const ChangeServicesModal = ({ open, steps, title, loading, handleClick, currentGroup }) => {
  return (
    <BaseModal
      size="lg"
      open={open}
      ChangeVehicleGroupServicesModal
      loading={false}
      handleClick={handleClick}
      title={title || i18n.t('vehicle_groups.edit_services')}
      maxWidth={1000}
    >
      <VehiclesGroupsServices isModal fleet={currentGroup} />
    </BaseModal>
  );
};

ChangeServicesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangeServicesModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeServicesModal;
